import { Component, Input } from '@angular/core';

@Component({
    selector: 'sensor-loading',
    templateUrl: 'sensorloading.component.pug',
    styleUrls: [ 'sensorloading.component.sass'],
  })
  export class SensorLoadingComponent{

  }